import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mapIdsToObjects',
})
export class MapIdsToObjectsPipe<K, V> implements PipeTransform {
  transform(idList: K[], idToObjectMap: Map<K, V>): V[] {
    return idList.map((id: K) => idToObjectMap.get(id)).filter((item): item is V => !!item);
  }
}
